import { StatusBadge } from "@/components/StatusBadge";
import { Image as ImageIcon, VideoCamera, LinkSimple, ArrowClockwise } from "@phosphor-icons/react";

export default function SubmissionCard({ submission, onClick, onResubmit, showResubmit }) {
  const s = submission;
  const MediaIcon = s.media_type === "video" ? VideoCamera : s.media_type === "link" ? LinkSimple : ImageIcon;

  return (
    <div
      onClick={onClick}
      data-testid={`submission-card-${s.id}`}
      className="cursor-pointer rounded-xl border border-white/10 bg-zinc-900/60 hover:border-yellow-400/30 transition-colors p-5 card-hover"
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 min-w-0">
          <div className="w-9 h-9 rounded-lg bg-zinc-800 flex items-center justify-center flex-shrink-0">
            <MediaIcon size={18} weight="duotone" className="text-yellow-400" />
          </div>
          <div className="min-w-0">
            <div className="font-heading font-bold text-sm truncate">{s.campaign_name || "Campaign"}</div>
            <div className="text-xs text-zinc-500 font-mono truncate">#{s.id.slice(0, 8)} · by {s.influencer_name}</div>
          </div>
        </div>
        <StatusBadge status={s.status} />
      </div>

      <p className="text-sm text-zinc-300 line-clamp-2 mb-3">{s.caption}</p>

      <div className="flex items-center justify-between text-xs text-zinc-500">
        <span className="font-mono">
          {s.revision_count > 0 && <span className="text-blue-400 mr-2">Rev {s.revision_count}</span>}
          {new Date(s.updated_at).toLocaleDateString()}
        </span>
        {showResubmit && s.status === "rejected" && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onResubmit(s);
            }}
            data-testid={`resubmit-button-${s.id}`}
            className="text-yellow-400 hover:text-yellow-300 font-medium flex items-center gap-1"
          >
            <ArrowClockwise size={14} weight="bold" /> Resubmit
          </button>
        )}
      </div>
    </div>
  );
}
